import { ApplicationContext, Environment } from './shared-types'

const appContext: ApplicationContext = {
  globalObject: window,
  onDomLoad: window.onDomLoad,
  eventHub: window.eventHub,
  environment: Environment.Undetermined,
}

export default appContext
